<template>
    <div class="configurator-sub-title mt-5 mb-4" v-bind:id="id">
        <h2>{{ title }}</h2>
    </div>
</template>

<script>
    export default {
        name: 'SubTitle',
        props: {
            title: String,
            id: String
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .configurator-sub-title h2 {
        font-size: 24px;
        font-weight: bold;
        line-height: 1.2;
        letter-spacing: 0.38px;
        text-transform: uppercase;
    }
    .configurator-sub-title h2:after {
        content: '';
        display: block;
        border-bottom: 1px solid #afb0af;
        margin-top: 10px;
    }
</style>